"use client";

import React, { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import Checkbox from "@/shared/Checkbox";
import ButtonThird from "@/shared/ButtonThird";
import ButtonPrimary from "@/shared/ButtonPrimary";
import { useAppDispatch, useAppSelector } from "@/app/lib/hooks";
import { setFilter } from "@/app/lib/reducers/toursReducer";
import { useTranslation } from 'react-i18next';




const SpecialFilters: React.FC = () => {
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state) => state.tours.filters.specialFilters);
  const { t } = useTranslation("guydeez");

  const specialFilterOptions = [
    { name: t('filters_promotion'), value: "promotion" },
    { name: t('filters_favorite'), value: "favorite" },
    { name: t('filters_new'), value: "isNew" },
    { name: t('filters_likely_to_sell_out'), value: "likelyToSellOut" },
  ];

  const handleChange = (val: string) => {
    const updated = selected.includes(val)
      ? selected.filter((v) => v !== val)
      : [...selected, val];
    dispatch(setFilter("specialFilters", updated));
  };

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button
            className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border ${
              open ? "!border-primary-500" : "border-neutral-300 dark:border-neutral-700"
            } hover:border-neutral-400 dark:hover:border-neutral-600 focus:outline-none`}
          >
            <span>Special Filters</span>
            <i className="las la-angle-down ml-2" />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-50 w-screen max-w-sm px-4 mt-3 sm:px-0 lg:max-w-md">
              <div className="rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border dark:border-neutral-700">
                <div className="flex flex-col px-5 py-6 space-y-5">
                  {specialFilterOptions.map((item) => (
                    <Checkbox
                      key={item.value}
                      name={item.name}
                      label={item.name}
                      defaultChecked={selected.includes(item.value)}
                      onChange={() => handleChange(item.value)}
                    />
                  ))}
                </div>
                <div className="p-5 bg-neutral-50 dark:bg-neutral-900 border-t dark:border-neutral-800 flex justify-between">
                  <ButtonThird onClick={close}>{t('filter_clear')}</ButtonThird>
                  <ButtonPrimary onClick={close}>{t('filter_apply')}</ButtonPrimary>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default SpecialFilters;
